import isEmpty from "lodash-es/isEmpty"
import isNull from "lodash-es/isNull"

import type {
    IAttendanceParticipantModuleDto,
    IAttendanceParticipantModuleModel,
    IModuleBaseDto,
    IModuleBaseModel,
    IModuleExcerptAssociatedSessionDto,
    IModuleExcerptAssociatedSessionModel,
    TModulePhaseProgressStatusDto,
    TModulePhaseTrackStatusDto
} from "@/3514/types"
import { EModulePhaseProgressStatus, EModulePhaseTrackStatus } from "@/3514/types"

import { getSessionInvitationStatusEnumFromType } from "./session.adapter"

function getModulePhaseTrackStatusEnumFromType(status: TModulePhaseTrackStatusDto): EModulePhaseTrackStatus {
    switch (status) {
        case "on_track":
            return EModulePhaseTrackStatus.OnTime
        case "late":
            return EModulePhaseTrackStatus.Late
        case "not_started":
        default:
            return EModulePhaseTrackStatus.NotStarted
    }
}

function getModulePhaseProgressEnumFromType(progress: TModulePhaseProgressStatusDto): EModulePhaseProgressStatus {
    switch (progress) {
        case 1:
            return EModulePhaseProgressStatus.FirstChapterCompleted
        case 2:
            return EModulePhaseProgressStatus.SecondChapterCompleted
        case 3:
            return EModulePhaseProgressStatus.ThirdChapterCompleted
        case -1:
        case 0:
        default:
            return EModulePhaseProgressStatus.NotAvailable
    }
}

function getModuleExcerptAssociatedSessionModelFromDto(
    session: IModuleExcerptAssociatedSessionDto
): IModuleExcerptAssociatedSessionModel {
    return isNull(session)
        ? null
        : {
              id: session.id,
              isManual: session.is_manual,
              coach: session.coach,
              status: getSessionInvitationStatusEnumFromType(session.status)
          }
}

function moduleBaseAdapter(dto: IModuleBaseDto): IModuleBaseModel {
    return isEmpty(dto)
        ? null
        : {
              category: dto.category,
              categoryDescription: dto.category_description,
              id: dto.id,
              isAssigned: dto.is_assigned,
              isCompleted: dto.is_completed,
              moduleDescription: dto.module_description,
              title: dto.title_pref_lang,
              version: dto.version
          }
}

function attendanceParticipantModuleAdapter(dto: IAttendanceParticipantModuleDto): IAttendanceParticipantModuleModel {
    return isEmpty(dto) ? null : { ...moduleBaseAdapter(dto), isEnrolled: dto.enrolled }
}

export {
    getModulePhaseTrackStatusEnumFromType,
    getModulePhaseProgressEnumFromType,
    getModuleExcerptAssociatedSessionModelFromDto,
    moduleBaseAdapter,
    attendanceParticipantModuleAdapter
}
